export class DriverLicense {
  _id?: string;
  driversId: string;
  nameLast: string;
  nameFirst: string;
  nameMiddle: string;
  expirationDate: string;
  issueDate: string;
  birthDate: string;
  gender: string;
  eyeColor: string;
  hairColor: string;
  height_ft: string;
  height_in: string;
  weight: string;
  addressStreet: string;
  addressCity: string;
  addressState: string;
  addressPostalCode: string;
  documentDiscriminator: string;
  country: string;
  nameLastTruncation: string;
  nameFirstTruncation: string;
  nameMiddleTruncation: string;
  auditInformation: string;
  inventoryControlNumber: string;
  turnsEighteen: string;
  turnsTwentyOne: string;
  complianceType: string;
  organDonor: string;
  cardRevisionDate: string;
  specificVehicleClass: string;
  drivingPrivileges: string;
  endorsementCodes: string;
  licenseNumber: string;
  vehicleClass: string;
  restrictionCodes: string;
}
const parsingElementIds: string[] = [
  'DAQ', // drivers id
  'DCA', // specific vehicle class
  'DCB', //  driving privileges
  'DCD', // endorsement codes
  'DBA', // expiration date
  'DCS', // last name
  'DAC', // first name
  'DAD', // middle name --  In the case of multiple middle names they shall be separated by a comma “,”.
  'DBD', // issue date format: MMDDCCYY
  'DBB', // birth date format: MMDDCCYY
  'DBC', // physical description – sex
  'DAY', // eye color
  'DAU', // height  --number of inches followed by " in"
  'DAG', // address street
  'DAI', // address city
  'DAJ', // address state --------------------issue--- missing value
  'DAK', // address postal  -----------------------issue -- not being evaluated
  'DCF', // document discriminator
  'DCG', // country identification
  'DDE', // Family name truncation
  'DDF', // First name truncation
  'DDG', // Middle name truncation
  'DAZ', // hair color
  'DCK', // Inventory control number
  'DDA', // Compliance Type---------------------------jumps to here
  'DDB', // Card Revision Date - (MMDDCCYY)
  'DAW', // weight in lbs
  'DDH', // Under 18 till
  'DDJ', // Under 21 till
  'DDK', // Organ Donor
];

export function parsePDF417(pdf417String: string): DriverLicense {
  const data: Partial<DriverLicense> = {};

  for (let i = 0; i < parsingElementIds.length; i++) {
    const currentId = parsingElementIds[i];
    const nextId = parsingElementIds[i + 1];
    const startIndex = pdf417String.indexOf(currentId) + currentId.length;
    const endIndex = nextId
      ? pdf417String.indexOf(nextId)
      : pdf417String.length;
    const value = pdf417String.slice(startIndex, endIndex).trim();

    // Remove the matched element and its value from the string
    pdf417String = pdf417String.replace(`${currentId}${value}`, '');
    switch (currentId) {
      case 'DAQ':
        data.licenseNumber = value;
        data.driversId = value;
        break;
      case 'DCA':
        data.vehicleClass = value;
        break;
      case 'DCB':
        data.restrictionCodes = value;
        break;
      case 'DCD':
        data.endorsementCodes = value;
        break;
      case 'DBA':
        data.expirationDate = dateFormatter(value);
        break;
      case 'DCS':
        data.nameLast = value;
        break;
      case 'DAC':
        data.nameFirst = value;
        break;
      case 'DAD':
        data.nameMiddle = value;
        break;
      case 'DBD':
        data.issueDate = dateFormatter(value);
        break;

      case 'DBB':
        data.birthDate = dateFormatter(value);
        break;
      case 'DBC':
        switch (value.trim().toUpperCase()) {
          case 'M':
          case '1':
            data.gender = 'Male';
            break;
          case 'F':
          case '2':
            data.gender = 'Female';
            break;
          case 'X':
          case 'N':
            data.gender = 'Non-Binary';
            break;
          default:
            data.gender = '';
        }
        break;
      case 'DAY':
        data.eyeColor = value;
        break;
      case 'DAU':
        data.height_ft = heightConverter(value, 'ft');
        data.height_in = heightConverter(value, 'in');
        break;
      case 'DAG':
        data.addressStreet = value;
        break;
      case 'DAI':
        data.addressCity = value;
        break;
      case 'DAJ':
        data.addressState = value.padEnd(2).substring(0, 2);
        break;
      case 'DAK':
        data.addressPostalCode = value.substring(0, 5);
        break;
      case 'DCF':
        data.documentDiscriminator = value;
        break;
      case 'DCG':
        data.country = value;
        break;
      case 'DDE':
        data.nameLastTruncation = value;
        break;
      case 'DDF':
        data.nameFirstTruncation = value;
        break;
      case 'DDG':
        data.nameMiddleTruncation = value;
        break;
      case 'DAZ':
        data.hairColor = value;
        break;
      case 'DCK':
        data.inventoryControlNumber = value;
        break;
      case 'DDA':
        data.complianceType = value;
        break;
      case 'DDB':
        data.cardRevisionDate = dateFormatter(value);
        break;
      case 'DAW':
        data.weight = value;
        break;
      case 'DDH':
        data.turnsEighteen = dateFormatter(value);
        break;
      case 'DDJ':
        data.turnsTwentyOne = dateFormatter(value);
        break;
      case 'DDK':
        data.organDonor = value === '1' ? 'T' : 'F';
        break;
      default:
        console.error(`Unhandled key: ${currentId}, value: ${value}`);
        break;
    }
  }

  return data as DriverLicense;
}

// const pdf417String =
//   'ANSI 636050080001DL00310287DL' +
//   'DAQZA134608C' + // DAQ - License number
//   'DCAB' + // DCA - Jurisdiction specific vehicle class
//   'DCBNONE' + // DCB - Jurisdiction specific restriction codes
//   'DCDM' + // DCD - Jurisdiction specific endorsement codes
//   'DBA02012027' + // DBA - Expiration Date
//   'DCSPATTERSON' + // DCS - Last Name
//   'DACBRIAN' + // DAC - First Name
//   'DADD' + // DAD - Middle Name-----------good to here
//   'DBD01202023' + // DBD -  Issue Date
//   'DBB02011979' + // DBB - Date of Birth
//   'DBC1' + // DBC - Sex
//   'DAYBRO' + // DAY - Eye color
//   'DAU067 in' + // DAU - Height in inches
//   'DAG1858 W HAM RAPIDS ST' + // DAG - address street
//   'DAIMERIDIAN' + // DAI - address city
//   'DAJID' + // DAJ - address state
//   'DAK836464667' + // DAK - address zip code
//   'DCF012230200066' + // DCF - Document Discriminator
//   'DCGUSA' + // DCG - Country Identification
//   'DDEN' + // DDE - Family name truncation
//   'DDFN' + // DDF - First name truncation
//   'DDGN' + // DDG  - Middle name truncation
//   'DAZBRO' + // DAZ - Hair color
//   'DCK0003530434' + // DCK - Inventory control number
//   'DDAF' + // DDA - Compliance Type - “F” = compliant; and, “N” = non-compliant.
//   'DDB01010001' + // DDB - Card Revision Date - (MMDDCCYY)
//   'DAW200' + // DAW - Weight
//   'DDH02011997' + // DDH - Under 18 till
//   'DDJ02012000' + // DDJ - Under 21 till
//   'DDK1'; // DDK - Organ Donor

// const parsedData = parsePDF417(pdf417String);
// console.log(parsedData);

export function dateFormatter(date: string): string {
  const year = date.slice(4, 8);
  const month = date.slice(0, 2);
  const day = date.slice(2, 4);
  return `${month}-${day}-${year}`;
}

export function heightConverter(height: string, return_type: string): string {
  const inches = parseInt(height, 10);
  const feet = Math.floor(inches / 12);
  const remainingInches = inches % 12;
  if (return_type === 'ft') {
    return `${feet}`;
  } else {
    return `${remainingInches}`;
  }
}
